import { VEHICLES_DETAILS } from './index';
import { Action } from '../action';
import { Vehicule } from '@shared/core';

export class VehiclesDetailsInitAction implements Action {
	readonly type = VEHICLES_DETAILS.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class VehiclesDetailsDestroyAction implements Action {
	readonly type = VEHICLES_DETAILS.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class VehiclesDetailsClickAddAction implements Action {
	readonly type = VEHICLES_DETAILS.CLICK_ADD;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class VehiclesDetailsClickEditAction implements Action {
	readonly type = VEHICLES_DETAILS.CLICK_EDIT;
	constructor(
		public payload: Vehicule,
		public correlationId?: number
	) {}
}

export class VehiclesDetailsClickDeleteAction implements Action {
	readonly type = VEHICLES_DETAILS.CLICK_DELETE;
	constructor(
		public payload: Vehicule,
		public correlationId?: number
	) {}
}
